import filter from 'lodash/filter';
import find from 'lodash/find';
import keys from 'lodash/keys';
import map from 'lodash/map';
import findIndex from 'lodash/findIndex';
import {
    excludedFromStandard,
    includedFromAdditional,
    SignalNames
} from './constants';
import { chartColors } from 'helpers/constants';
import { getTranslatedKPINameV2 } from 'helpers/translateHelper';
import {
    createParamMeasurementComponentObjV2,
    getFlatAvailableKPIList
} from '../../../commonTrendHelpers';
import { TIME_SERIES_CATEGORY } from '../../CommonCharts/Trend/constants';


const getStandardKPIsToDisplay = (standardKPIs) => {
    return filter(keys(standardKPIs), (kpi) => {
        const kpiData = standardKPIs[kpi];
        const isPowerSignal = kpi?.toLowerCase() === SignalNames.POWER.toLowerCase();
        const isEnergySignal = kpiData?.timeseriesCategory === TIME_SERIES_CATEGORY.ENERGY;
        return !find(excludedFromStandard, (excludedKPI) => {
            return kpi === excludedKPI || isEnergySignal && !isPowerSignal;
        });
    });
};

const getAdditionalKPIsToDisplay = (additionalKPIs) => {
    return filter(keys(additionalKPIs), (kpi) => {
        const isPowerSignal = kpi?.toLowerCase() === SignalNames.POWER.toLowerCase();
        const isEnergySignal = additionalKPIs[kpi]?.timeseriesCategory === TIME_SERIES_CATEGORY.ENERGY;
        return find(includedFromAdditional, (includedKPI) => {
            return kpi === includedKPI && (!isEnergySignal || isPowerSignal);
        });
    });
};


export const getMultiGraphConfig = (kpis) => {
    if (!kpis || kpis.length === 0) {
        return [];
    }
    const allKPIs = [];
    allKPIs.push(...getStandardKPIsToDisplay(kpis[0].data));
    for (let i = 1; i < kpis.length; i++) {
        allKPIs.push(...getAdditionalKPIsToDisplay(kpis[i].data));
    }
    return allKPIs;
};

export const formatMultiGraphRequest = (kpisToDisplay, allKPIs, selectedAsset) => {
    const availableKPIs = getFlatAvailableKPIList(allKPIs);

    const measurementTypes = map(kpisToDisplay, (kpi) => {
        return availableKPIs[kpi];
    });

    return createParamMeasurementComponentObjV2(measurementTypes, selectedAsset);
};

export const getUserLimitsForChart = (userLimits, kpis) => {
    const userLimitsForKPI = filter(userLimits, (userLimit) => {
        return findIndex(kpis, (kpi) => userLimit.signalCode.toLowerCase() === kpi.toLowerCase()) > -1;
    });
    return userLimitsForKPI || [];
};

export const formatMultiTrendData = ({ data, isZoomed, from = null, to = null } = {}, loadingStatus) => {
    const multiTrendData = map(data, (chartData) => {
        return {
            kpiList: [{
                color: chartColors[0],
                values: chartData.values,
                kpiIdentifier: chartData?.config?.timeseriesKey
            }],
            zoom: { isZoomed: isZoomed, from, to },
            loadingStatus: loadingStatus,
            chartName: getTranslatedKPINameV2(chartData.config),
            chartID: chartData?.config?.timeseriesKey
        };
    });

    return multiTrendData;
};

export const setMultiTrendDataToLoadingStatus = (charts, isZoomed, from, to, loadingStatus, error = null) => {
    const multiTrendData = map(charts, (chartData) => {
        return {
            ...chartData,
            zoom: { isZoomed: isZoomed, from, to },
            loadingStatus,
            ...error ? { error } : {}
        };
    });

    return multiTrendData;
};
